export function formatDeliveryHour(deliveryHour: number) {
  if (deliveryHour < 0) {
    const hours = Math.abs(deliveryHour)
    return `${hours} hour${hours === 1 ? '' : 's'} before shift starts`
  }
  if (deliveryHour === 0) {
    return 'At shift start'
  }
  return `${deliveryHour} hour${deliveryHour === 1 ? '' : 's'} after shift starts`
}
